import { Box } from "@mui/material";
import React from "react";
import {
  Gallery,
  TopDrawer,
  useActiveUnit,
} from ".";
import { useUnitHighlight } from "./hooks";
import {  useAtom, useGet } from "state/jotai";
import { _drawer, active_project, hardCodeUnit} from 'state/store.global'
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import { useBreak } from "hooks/useBreak";
import { Scrollbar } from "react-scrollbars-custom";
import { useLocation } from "react-router-dom";
import { _bootstrap } from "state/store.bootstrap";
import areaUnitdata from "./hardcodeAreaData/area";


function HardCodeUnitDrawer() {
  const here = useLocation().pathname;
  const { pin, pid }         = useGet(active_project);
  const [hcUnit, setHardCodeUnit] = useAtom(hardCodeUnit);
  const uData = areaUnitdata[pid]?.[hcUnit?.type]?.[hcUnit?.id]?.Data || {};
  const unit = useActiveUnit();
  

  const highlights = useUnitHighlight(unit);
  const unitId = parseInt(unit.getId());
  const status = unit.getStatus();
  const address = unit.getAddress();
  const moveindate = unit.getMoveInDate();
  const townAndZipcode = unit.getTownZipCode();
  const topicCode = unit?.data?.Data?.Egen_emne_kode?.Value


  
  const isMobile = useBreak('md_dn')
  const drawer   = useAtom(_drawer)[0] 
  const isDetail = drawer.detail
  const thumbnails = uData?.gallery?.map(( img ) => ({ url: img })) || [];
  const images = uData?.gallery?.map(( img ) => ({ url: img })) || [];

  const today = Boolean(moveindate) ? new Date(moveindate) : false;

  // Specify Danish as the locale and customize options
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  const danishFormattedDate = today ? today.toLocaleDateString('da-DK', options) : false;

   
  return (
    <Box
      sx={{
        width: "100%",
        height:isMobile?"calc(100% - 73px)": "calc(100% - 165px)",
        backgroundColor: "#ffffff",
        overflowY: "auto",
        scrollbarWidth: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderLeft:`1px solid ${clr?.primary}`,
      }}
    >
        <Scrollbar trackYProps={{
          renderer: (props) => {
            const { elementRef, ...restProps } = props;
            return <span {...restProps} ref={elementRef}
            className="trackY" />;
          },
        }}
        contentProps={{
          renderer: (props) => {
            const { elementRef, ...restProps } = props;
            return <span {...restProps} ref={elementRef} style={{ height: "100%", display: "block" }} className="Content" />;
          },
        }}
        >
      <Box sx={{ display: 'flex', flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
      <div>
        <Box sx={{position:"relative", zIndex:2}}>
        <TopDrawer
        isHardCode={true}
          availableDate={danishFormattedDate}
          address={uData?.headline}
          topicCode={topicCode}
          statusText={hcUnit?.type}
          statusId={status.id}
          backgroundColor={hcUnit?.type === "Erhverv" ? "#8DB9E4" : "#DCAACF"}
          textColor="#ffffff"
        />
        </Box>
        <Box sx={{position:"relative",top:"-4px", zIndex:1, background: 'white'}}>
        <Gallery isDetail={isDetail} unitId={unitId} images={images} thumbImg={thumbnails} UnitDrawer width = {isMobile ? ' 100%' : '375px'}  height = {isMobile ? '273px' : '273px'} />
        <Box sx={{ padding: isMobile ? '16px' : '24px' }}>
          <Box sx={{ mb: 2 }}>
            {uData.headline && <Box className="h4">{uData.headline}</Box>}
          </Box>
          <Box>
            {uData.description && <Box className="paragraph1-light">{uData.description}</Box>}
          </Box>
        </Box>
        </Box>
      </div>
      <PoweredBy />
      </Box>
        </Scrollbar>
    </Box>
  );
}

export default HardCodeUnitDrawer;
